import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-50" data-mp="boolb2dcrt3f">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-51" data-mp="196gbaw88qjp1">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl border-2 border-gold bg-cta px-4 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_12px_32px_-6px_rgba(0,0,0,0.45)] transition-colors duration-150 ease-out hover:bg-cta-dark sm:text-lg" data-id="element-52" data-mp="2f4k8z2ptobs2">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-53" data-mp="1wdj8ga92086e" />
            Get it now for only $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}